import React, { useEffect, useRef, useState } from "react"
import Loader from "react-loaders"
import { useDispatch, useSelector } from "react-redux"
import NameAvatar from "components/custom/nameAvatar"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import {
  changeResourceBudgeting,
  changeResourcePlanning,
  loadPageItem,
} from "store/actions"
import colors from "utils/colors"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TShirtHoursAllocationModal from "pages/Projects/EditProject/Modals/TShirtHoursAllocationModal"
import { getAlternativeYears } from "utils/alternativeHelper"
import { enrichWithPhotoBase64 } from "utils/avatar"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"

const ResourcePlanning = props => {
  var gridRef = useRef(null)
  const currentUser = userService.getLoggedInUser()
  const scenarioId = props.match.params.scenarioId
  //plan if planning, budget if budgeting
  const budgetOrPlan = props.budgetOrPlan
  const isPlanning = budgetOrPlan == "plan"
  const dispatch = useDispatch()
  const { pageItem } = useSelector(state => ({
    pageItem: state.pageItem.pageItem,
  }))
  const [isLoading, setIsLoading] = useState(false)
  const [isGridLoading, setIsGridLoading] = useState(false)
  const selectedType = budgetOrPlan
  const [years, setYears] = useState([])
  const [gridData, setGridData] = useState([])
  const [columns, setColumns] = useState([])
  const [cols, setCols] = useState([])

  const { resourcePlanningDefaults } = useSelector(state => ({
    resourcePlanningDefaults: state.resourcePlanning.resourcePlanning,
  }))
  const { resourceBudgetingDefaults } = useSelector(state => ({
    resourceBudgetingDefaults: state.resourceBudgeting.resourceBudgeting,
  }))

  const [showTShirtModal, setShowTShirtModal] = useState(false)
  const toggleTShirtModal = () => setShowTShirtModal(prev => !prev)

  const [
    resourceGroupBundleIdForTShirtModal,
    setResourceGroupBundleIdForTShirtModal,
  ] = useState(null)
  const [alternative, setAlternative] = useState(null)
  const [alternativeYears, setAlternativeYears] = useState([])

  const optionsObject = isPlanning
    ? resourcePlanningDefaults
    : resourceBudgetingDefaults
  const setOptionsProp = (prop, option) => {
    if (isPlanning) {
      dispatch(
        changeResourcePlanning({
          // ...resourcePlanningDefaults,
          [prop]: option,
        })
      )
    } else {
      dispatch(
        changeResourceBudgeting({
          // ...resourceBudgetingDefaults,
          [prop]: option,
        })
      )
    }
  }

  useEffect(() => {
    if (isPlanning) {
      dispatch(
        loadPageItem({
          userId: currentUser.userID,
          scenarioId: scenarioId,
          alternativeId: 0,
          viewName: "resourcePlanning",
        })
      )
      loadData()
    } else {
      dispatch(
        loadPageItem({
          userId: currentUser.userID,
          scenarioId: scenarioId,
          alternativeId: 0,
          viewName: "resourceEstimating",
        })
      )
      loadData()
    }

  }, [])

  const loadData = async () => {
    setIsLoading(true)

    let y = []
    if (isPlanning) {
      y = await api.getScenarioList(scenarioId, "ScenarioYears")
    } else {
      let s = await api.getScenario(scenarioId)
      y = [
        s.fyYear,
        s.fyYear + 1,
        s.fyYear + 2,
        s.fyYear + 3,
        s.fyYear + 4,
      ].map(x => {
        return { listItemID: x, listItemName: x }
      })
    }
    setYears(y)

    await loadGrid(
      currentUser.userID,
      scenarioId,
      // y !== null && y.length > 0 ? y[0].listItemID : new Date().getFullYear(),
      0,
      optionsObject.showExcluded,
      optionsObject.showOption,
      selectedType
    )
    setIsLoading(false)
  }

  const loadGrid = async (
    userId,
    scenarioId,
    year,
    showExcluded,
    show,
    planbudget
  ) => {
    setIsGridLoading(true)
    let data = await api.getAlternativeResourceStatus(
      userId,
      scenarioId,
      year,
      showExcluded,
      show,
      planbudget
    )

    let scenario = await api.getScenario(scenarioId)
    const planningCategoryLabel = await api.getEnterpriseLabel(
      scenario?.enterpriseID ?? currentUser.enterpriseID,
      "Planning Category"
    )

    let c = [
      {
        headerText: "Project",
        field: "alternative",
        width: 250,
        headerFilter: "input",
        freeze: "Left",
        template: data => (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <a
              href="#"
              onClick={e => {
                e.preventDefault()
                props.history.push(
                  `/editProject/${scenarioId}/${data.alternativeID}`
                )
              }}
            >
              {data.alternative}
            </a>
          </div>
        ),
      },
      {
        headerText: "Version",
        field: "version",
        freeze: "Left",
        width: 100,
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html: data.version,
                }}
              ></div>
            )
          },
        },
        template: data => (
          <div
            style={{ lineHeight: "20px" }}
            dangerouslySetInnerHTML={{
              __html: data.version,
            }}
          ></div>
        ),
        textAlign: "center",
      },
      {
        headerText: "Business Case Status",
        field: "bcState",
        width: 200,
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html: data.bcState,
                }}
              ></div>
            )
          },
        },
        template: data => (
          <div
            style={{ lineHeight: "20px" }}
            dangerouslySetInnerHTML={{
              __html: data.bcState,
            }}
          ></div>
        ),
      },
      {
        headerText: "FY Planned",
        field: "fyPlanned",
        width: 120,
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html: data.fyPlanned,
                }}
              ></div>
            )
          },
        },
        template: data => (
          <div
            style={{ lineHeight: "20px" }}
            dangerouslySetInnerHTML={{
              __html: data.fyPlanned,
            }}
          ></div>
        ),
      },
      {
        headerText: "Project Manager",
        field: "pm",
        width: 200,
        type: "string",
        filter: {
          type: "Excel",
          itemTemplate: data => <span>{data.pm}</span>,
        },
        template: data => (
          <NameAvatar
            fullName={data.pm}
            showName={true}
            base64Image={data.pmPhotoBase64 ?? ""}
          />
        ),
      },
      {
        headerText: planningCategoryLabel,
        field: "projectCategory",
        width: 230,
        clipMode: "EllipsisWithTooltip",
      },
    ]
    if (data.length > 0) {
      setColumns(Object.keys(data[0]).filter(key => key.indexOf("c:") > -1))
      let otherCols = Object.keys(data[0]).filter(key => key.indexOf("c:") > -1)

      if (otherCols.length > 0) {
        otherCols.forEach(col => {
          if (show == "20") {
            c.push({
              headerText: col.replace("c:", ""),
              field: col,
              width: 110,
              template: data => {
                let { resourceGroupId, tShirtBundleId, newVal } =
                  extractAndRemoveResourceGroupId(data[col])

                if (resourceGroupId != null) {
                  if (newVal == undefined || newVal == null || newVal == "") {
                    return (
                      <div
                        style={{
                          margin: "0",
                          textAlign: "center",
                          display: "inline-block",
                          padding: "4px 10px",
                          borderRadius: "15px",
                          borderColor: "lightgray",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          color: "blue",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          loadTShirtModal(
                            resourceGroupId,
                            tShirtBundleId,
                            data.alternativeID
                          )
                        }}
                      >
                        <i className="fas fa-tshirt"></i>&nbsp;T-Shirt
                      </div>
                    )
                  } else {
                    return (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: newVal,
                        }}
                        onClick={() => {
                          loadTShirtModal(
                            resourceGroupId,
                            tShirtBundleId,
                            data.alternativeID
                          )
                        }}
                      ></div>
                    )
                  }
                } else {
                  return (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: newVal,
                      }}
                    ></div>
                  )
                }
              },
            })
          } else {
            c.push({
              headerText: col.replace("c:", ""),
              field: col,
              width: 110,
              template: data => (
                <div
                  style={{ lineHeight: "20px" }}
                  dangerouslySetInnerHTML={{
                    __html: data[col],
                  }}
                ></div>
              ),
            })
          }
        })
      }
    } else {
      setColumns([])
    }
    setCols(c)
    data = await enrichWithPhotoBase64(data, "pmID")
    setGridData(data)
    setIsGridLoading(false)

  }

  const loadTShirtModal = async (resourceGroupId, tShirtBundleId, altId) => {
    setResourceGroupBundleIdForTShirtModal({ resourceGroupId, tShirtBundleId })
    let alt = await api.getAlternative(altId)
    setAlternative(alt)
    setAlternativeYears(getAlternativeYears(alt))

    toggleTShirtModal()
  }

  function extractAndRemoveResourceGroupId(str) {
    const regex = /{(\d+)\|(\d+)}/

    const matches = str.match(regex)
    let resourceGroupId = null
    let tShirtBundleId = null
    if (matches) {
      resourceGroupId = matches[1]
      tShirtBundleId = matches[2]
    }

    const newVal = str.replace(regex, "").trim()

    return { resourceGroupId, tShirtBundleId, newVal }
  }

  const applyTShirtHoursAllocation = async updatedCostPools => {
    let copy = [...updatedCostPools]

    copy.forEach(cp => {
      let total = 0
      alternativeYears.forEach(y => {
        cp[`c-${y}`] = cp[`updated-${y}`]
        total += cp[`updated-${y}`]
      })
      cp[`c-Total`] = total
    })

    let itemsToUpdate = []
    updatedCostPools.forEach(cp => {
      alternativeYears.forEach(i => {
        itemsToUpdate.push({
          resourceGroupID: cp.resourceGroupID,
          alternativeID: cp.alternativeID,
          costPoolID: cp.costPoolID,
          yearID: i,
          numUnits: parseInt(cp[`c-${i}`]),
        })
      })
    })

    console.log(itemsToUpdate)

    if (itemsToUpdate.length > 0) {
      let itemsToUpdateTasks = itemsToUpdate.map(x => async () => {
        return await api.updateAlternativeResourceBudget(currentUser.userID, x)
      })
      await Promise.all(itemsToUpdateTasks.map(t => t()))
    }
    let rowsToUpdate = updatedCostPools.map(x => {
      return {
        resourceGroupID: x.resourceGroupID,
        costPoolID: x.costPoolID,
        alternativeID: x.alternativeID,
        budgetNotes: x["c-Estimation Notes"],
        budgetStatusID: x.budgetStatusID,
        altRGValue: x["c-Total"],
      }
    })
    if (rowsToUpdate.length > 0) {
      let rowsToUpdateTasks = rowsToUpdate.map(x => async () => {
        return await api.updateAlternativeResourceFromBudget(
          currentUser.userID,
          x
        )
      })
      await Promise.all(rowsToUpdateTasks.map(t => t()))
    }

    await loadData()
  }

  const onGridActionComplete = args => {
    if (args.requestType === "filtering") {
      let filters = gridRef.current?.filterSettings?.columns ?? []
      localStorage.setItem(
        "resourcePlanningFilters",
        JSON.stringify(
          filters.map(({ field, operator, value, predicate, matchCase }) => ({
            field,
            operator,
            value,
            predicate,
            matchCase,
          }))
        )
      )
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={pageItem !== undefined ? pageItem.pageSubTitle : ""}
          />
          <Card>
            <CardBody>
              {isLoading && (
                <Loader
                  type="line-scale-pulse-out"
                  color={colors.primary}
                  style={{ textAlign: "center" }}
                />
              )}
              {!isLoading && (
                <>
                  <Row>
                    {/* <Col md="3">
                      <div className="mb-3">
                        <Label style={{ marginBottom: "0px" }}>Type</Label>
                        <select
                          className="form-control form-select select2 mb-xxl-0"
                          value={selectedType}
                          onChange={e => {
                            setSelectedType(e.target.value)
                            loadGrid(
                              currentUser.userID,
                              scenarioId,
                              selectedYear,
                              showExcluded,
                              selectedShow,
                              e.target.value
                            )
                          }}
                        >
                          <option value="budget">Resource Estimate</option>
                          <option value="plan">Resource Plan</option>
                        </select>
                      </div>
                    </Col> */}

                    <Col md="3">
                      <div className="mb-3">
                        <Label style={{ marginBottom: "0px" }}>
                          Show Resource Estimates for FY
                        </Label>
                        <select
                          className="form-control form-select select2 mb-xxl-0"
                          value={optionsObject.yearOption}
                          onChange={e => {
                            setOptionsProp("yearOption", e.target.value)
                            loadGrid(
                              currentUser.userID,
                              scenarioId,
                              e.target.value,
                              optionsObject.showExcluded,
                              optionsObject.showOption,
                              selectedType
                            )
                          }}
                        >
                          <option value="0">All</option>
                          {years.map((r, idx) => {
                            return (
                              <option key={idx} value={`${r.listItemID}`}>
                                {r.listItemName}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="mb-3">
                        <Label style={{ marginBottom: "0px" }}>Show</Label>
                        <select
                          className="form-control form-select select2 mb-xxl-0"
                          value={optionsObject.showOption}
                          onChange={e => {
                            setOptionsProp("showOption", e.target.value)
                            loadGrid(
                              currentUser.userID,
                              scenarioId,
                              optionsObject.yearOption,
                              optionsObject.showExcluded,
                              e.target.value,
                              selectedType
                            )
                          }}
                        >
                          <option value="0">Requested and Not Complete</option>
                          <option value="1">Requested and Complete</option>
                          <option value="10">All and Not Complete</option>
                          <option value="11">All and Complete</option>
                          <option value="20">
                            Project Hours and T-Shirt Size
                          </option>
                          <option value="-99">All</option>
                        </select>
                      </div>
                    </Col>
                    <Col
                      md="3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="show"
                        checked={optionsObject.showExcluded}
                        onClick={e => {
                          const val = !optionsObject.showExcluded
                          setOptionsProp("showExcluded", val)
                          loadGrid(
                            currentUser.userID,
                            scenarioId,
                            optionsObject.yearOption,
                            val,
                            optionsObject.showOption,
                            selectedType
                          )
                        }}
                      />
                      <Label
                        className="form-check-label"
                        for="show"
                        style={{ marginLeft: "10px" }}
                      >
                        Show Excluded from Planning Cycle
                      </Label>
                    </Col>
                  </Row>

                  <Row>
                    <Col style={{ overflowX: "auto" }}>
                      {isGridLoading && (
                        <Loader
                          type="line-scale-pulse-out"
                          color={colors.primary}
                          style={{ textAlign: "center" }}
                        />
                      )}
                      {!isGridLoading && cols.length > 0 && (
                        <SyncfusionGrid
                          filterSettings={{
                            type: "Excel",
                            columns: localStorage.getItem(
                              "resourcePlanningFilters"
                            )
                              ? JSON.parse(
                                  localStorage.getItem(
                                    "resourcePlanningFilters"
                                  )
                                )
                              : [],
                          }}
                          actionComplete={onGridActionComplete}
                          gridRef={gridRef}
                          columns={cols}
                          data={gridData}
                        />
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
      {alternative != null && (
        <TShirtHoursAllocationModal
          isOpen={showTShirtModal}
          toggleModal={toggleTShirtModal}
          resourceGroupBundleId={resourceGroupBundleIdForTShirtModal}
          alternativeYears={alternativeYears}
          applyTShirtHoursAllocation={applyTShirtHoursAllocation}
          alternativeId={alternative.alternativeID}
          alternativeName={alternative.alternativeName}
          scenarioId={alternative.scenarioID}
        />
      )}
    </React.Fragment>
  )
}

export default ResourcePlanning
